import React from 'react'

import { type MonthlyDistribution } from './ImportDataContext'
import { usd } from './importFormStyles'
import { RangeInput } from './RangeInput'

interface CategoryControlsProps {
  label: string
  color: string
  dist: MonthlyDistribution
  onChange: (d: Partial<MonthlyDistribution>) => void
  sliderMax: number
}

export const CategoryControls = ({ label, color, dist, onChange, sliderMax }: CategoryControlsProps) => (
  <div style={{ marginBottom: 20 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
      <div style={{ width: 10, height: 10, borderRadius: '50%', background: color, flexShrink: 0 }} />
      <strong style={{ fontSize: 14 }}>{label}</strong>
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: '68px 1fr 76px', alignItems: 'center', rowGap: 8, columnGap: 10 }}>
      <span style={{ fontSize: 12, color: '#6b7280' }}>Mean</span>
      <RangeInput value={dist.mean} max={sliderMax} step={100} color={color} onChange={v => onChange({ mean: v })} />
      <span style={{ fontSize: 13, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{usd.format(dist.mean)}</span>

      <span style={{ fontSize: 12, color: '#6b7280' }}>Std Dev</span>
      <RangeInput value={dist.stdDev} max={Math.max(Math.round(sliderMax / 4), 1)} step={50} color={color} onChange={v => onChange({ stdDev: v })} />
      <span style={{ fontSize: 13, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{usd.format(dist.stdDev)}</span>
    </div>
    <div style={{ display: 'flex', gap: 16, paddingLeft: 78, marginTop: 6 }}>
      {(['min', 'max'] as const).map(field => (
        <label key={field} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#6b7280' }}>
          {field === 'min' ? 'Min' : 'Max'}
          <input
            type='number' min={0} step={100} value={dist[field]}
            onChange={e => onChange({ [field]: Math.max(0, Number(e.target.value)) })}
            style={{ width: 76, fontSize: 12, padding: '2px 4px' }}
          />
        </label>
      ))}
    </div>
  </div>
)
